import { useAppDispatch, useAppState } from '@/store';
import { IUpdatePromotionDTO } from '@/models/promotion.model';
import { selectCouponsIsLoading, updateCoupon } from '../feature';

const useUpdateCoupon = () => {
  const dispatch = useAppDispatch();
  const isLoading = useAppState(selectCouponsIsLoading);

  const updateCouponData = async (dto: IUpdatePromotionDTO) => {
    await dispatch(updateCoupon(dto)).unwrap();
  };

  return {
    updateCoupon: updateCouponData,
    isLoading,
  };
};

export default useUpdateCoupon;
